<!--popup body-->
<div class="modal-body" style="overflow:hidden !important" id="popupbody">

  <div class="form-group">
    <div class="row">
      <div id="freelancerTestAssign">
        <div class="row" id="Filters">
          <button type="button" id="btnArticleCategory" (click)="GetArticleTitleList()" style="display:none">
            Get
          </button>
          <div class="col-sm-4 form-group">
            <label>ArticleNo</label>
            <select id="ddlArticle" class="form-control ddlselect" onchange="$('#btnArticleCategory').trigger('click');">
              <option value="Select">Select</option>
              <option *ngFor="let item of articleList" value={{item.ID}}>
                {{item.ArticleNo}}
              </option>
            </select>
          </div>
          <div class="col-sm-8 form-group">
            <label>ArticleTitle</label><span class="required">*</span>
            <input id="Txt_articleTitle" type="text" class="form-control" autocomplete="off" />
          </div>

        </div>
      </div>
      <div id="freelancerTestAss">
        <div class="row form-group">
          <div class="col-sm-4">
            <label>Expected Start Date</label>
            <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" (change)="GetDueDateValidationOnDate()" [min]="minDate" autocomplete="off">
          </div>
          <div class="col-sm-4">
            <label>DueDate</label>
            <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" [min]="minDate" (change)="GetDueDateValidationOnDate()" autocomplete="off">
          </div>
          <div class="col-sm-4" id="testfileuploadbtn">
            <label>ChooseFile</label><br />
            <input type="file" class="form-control" id="doc_testfile" (change)="onuploadSelected($event)" />
          </div>
        </div>
      </div>
      <div id="freelancerTestAss">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <label>Notes</label>
              <textarea cols="7" id="TXT_Remarks" class="form-control"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="HideAssignment()">Cancel</button>
  <button type="button" (click)="TestAssign()" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF">Assign</button>
</div>







